import { api } from "@/lib/api"

/**
 * PREGUNTARLE A MARTY.
 *
 *   GET  /marty/estado      ¿hay proveedor de modelo configurado?
 *   POST /marty/preguntar   contesta sobre las cifras de este cliente
 *
 * SIN MODO MOCK. Una respuesta simulada sobre las cifras de una empresa es
 * exactamente lo que esta pieza no puede hacer: el valor entero está en que lo
 * que diga salga de los datos de verdad, y un mock que suena igual de seguro
 * sería indistinguible de una respuesta real y estaría inventado.
 *
 * Vive en `lib/` y no en `routes/` porque el panel se monta en el layout: no es
 * de ninguna pantalla, está en todas.
 */

export interface EstadoDeMarty {
  disponible: boolean
  /** Por qué no, cuando no. Se enseña: esconder el panel se lee como «no existe». */
  motivo: string | null
}

export function estadoDeMarty(): Promise<EstadoDeMarty> {
  return api.get<EstadoDeMarty>("/marty/estado")
}

export interface RespuestaDeMarty {
  respuesta: string
  /** `alta` | `media` | `baja`. Se pinta aparte del texto, nunca dentro. */
  certeza: string
  /** Qué dato haría falta para contestar mejor, o `null`. */
  que_me_falta: string | null
  modelo: string
  ms: number
  /**
   * Los proveedores que fallaron antes de que uno contestara.
   *
   * Vacío = contestó el principal. Se enseña porque si no, el único rastro de
   * que el proveedor de cabecera está caído queda en el log del servidor —y la
   * primera prueba contra datos reales degradó por «sin créditos» sin que nada
   * se viera en pantalla.
   */
  degradaciones: { proveedor: string; causa: string }[]
  /**
   * El bloque exacto que se le pasó al modelo.
   *
   * Es la defensa contra una cifra inventada: quien dude puede cotejar sin
   * preguntarle a nadie. No se pinta por defecto —son 20 KB— pero viaja.
   */
  datos_usados: Record<string, unknown>
}

export function preguntarAMarty(datos: {
  pregunta: string
  /** La ruta que se está mirando. Es lo que hace que «¿y esto?» tenga sentido. */
  pantalla?: string
  anio?: number
  pais?: string
}): Promise<RespuestaDeMarty> {
  return api.post<RespuestaDeMarty>("/marty/preguntar", datos)
}
